export const URLS = {
  appStore: 'https://apps.apple.com/us/app/neat-mobile/id1490480504?mt=8',
  playStore: 'https://play.google.com/store/apps/details?id=com.neat.mobile&pli=1',
  social: {
    facebook: 'https://www.facebook.com/NeatCompany/',
    linkedin: 'https://www.linkedin.com/company/the-neat-company_2/',
    twitter: 'https://twitter.com/NeatCompany/',
    youtube: 'https://www.youtube.com/@TheNeatcompany',
  },

}

export const DEFAULT_PLAN_SKU = 'neatyr'

export const TRIAL_SKU = 'neatyrt'
export const NEAT_HOME_TRIAL_SKU = 'neathomeyrt'
export const NEAT_VIP_YEARLY_SKU = 'neatvipyr'
export const NEAT_AI_YEARLY_SKU = 'neataiyr'
export const NEAT_HOME_YEARLY_SKU = 'neathomeyr'
export const NEAT_HOME_VIP_YEARLY_SKU = 'neathomevipyr'

export const UPSELL_PLAN = 'neathomevipyr'
export const UPSELL_COUPON = 'HOMEVIPFALL24'
export const UPSELL_COUPON_DESCRIPTION = 'Free VIP Service'

// https://github.com/TheNeatCompany/StayPuft/blob/beaac1088cfbfad0f79a2e5ed8677939ef950e47/webapp/app/models/user_validations.rb#L4
export const EMAIL_REGEX = /^[a-z0-9*._+-]+@([a-z0-9._+-]+\.)+[a-z0-9._+-]+$/

export const RECAPTCHA_V3_ACTIONS = {
  FREE_TRIAL_EMAIL: 'free_trial_email',
  FREE_TRIAL_EXISTING_USER: 'free_trial_existing_user',
  FREE_TRIAL_RESET_PASSWORD_AUTHENTICATE: 'free_trial_reset_password_authenticate',
  FREE_TRIAL_RESET_PASSWORD_REQUEST: 'free_trial_reset_password_request',
  SIGNUP_CREATE_ORDER: 'signup_create_order',
  SIGNUP_EMAIL: 'signup_email',
  SIGNUP_EXISTING_USER: 'signup_existing_user',
  SIGNUP_PERSONAL_INFO: 'signup_personal_info',
  SIGNUP_RESET_PASSWORD_AUTHENTICATE: 'signup_reset_password_authenticate',
  SIGNUP_RESET_PASSWORD_REQUEST: 'signup_reset_password_request',
}

export default {}
